// extracted by mini-css-extract-plugin
export var leftAlign = "_34-2";
export var popper = "_34-0";
export var subtitle = "_34-1";